import React, { useState, useContext, createContext, useEffect } from "react";
import { useToken } from "components/helper/tokenContext";
import { LS_USER_KEY } from "constants/constants";
import { User } from "types/User";

type UserContextType = {
    user: User | null;
    setUser: React.Dispatch<React.SetStateAction<User | null>>;
};

type UserContextProviderProps = {
    children: React.ReactNode;
};

const UserContext = createContext<UserContextType>({
    user: null,
    setUser: () => {},
});

export const useUser = () => useContext(UserContext);

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
    const [user, setUser] = useState<User | null>(() => {
        const localUser = localStorage.getItem(LS_USER_KEY);
        return localUser ? JSON.parse(localUser) : null;
    });
    const { removeToken } = useToken();

    useEffect(() => {
        localStorage.setItem(LS_USER_KEY, JSON.stringify(user));
        if (!user) {
            removeToken();
        }
    }, [user, removeToken]);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};
